import {HeadersJson} from "./AuthTypes";

export class TokenRequest{
    headers: HeadersJson;
    body: string;

    constructor(headers: HeadersJson, body: string){
        this.headers = headers;
        this.body = body;
    }
}